import '@stylesheets/header/navbar.scss';
import '@stylesheets/themes/all.scss';

document.addEventListener('turbolinks:load', () => {
  const menuIconContainer = document.getElementById('nav-menu-container');
  const menuIcon = document.getElementById('nav-menu');
  const menuListContainer = document.getElementById('menu-list-container');
  const navBar = document.getElementById('navbar');

  const toggleClasses = (e, navClass, menuClass, menuContainerClass) => {
    e.stopImmediatePropagation();
    if (navBar) navBar.classList.toggle('collapse', navClass);
    if (menuIcon) menuIcon.classList.toggle('active', menuClass);
    if (menuIconContainer) menuIconContainer.classList.toggle('active', menuContainerClass);
  };

  if (menuIconContainer) {
    menuIconContainer.addEventListener('click', (e) => {
      toggleClasses(e);
    });
  }

  if (navBar) {
    navBar.addEventListener('click', (e) => {
      toggleClasses(e, true, false, null);
    });
  }

  if (menuListContainer) {
    menuListContainer.addEventListener('click', (e) => {
      toggleClasses(e, true, false, null);
    });
  }
});
